import dynamic from "next/dynamic";
import BoardTabTextAndAssetConfig from "./board-tab-text-and-asset-config";
import BoardTabTextAndAssetAdvancedConfig from "./board-tab-text-and-asset-advanced-config";
const BoardTabTextAndAssetComponent = dynamic(()=>import("./board-tab-text-and-asset-component"));
export default {
    BoardTabTextAndAssetComponent,
    BoardTabTextAndAssetConfig,
    BoardTabTextAndAssetAdvancedConfig
};
